export default "__VITE_ASSET__D75slOeH__"